import $ from 'jquery';
import _ from 'underscore';
import {setElementsFromScope, show, hide, handleDisplayFor, formatAddress} from '../../utilities/run';
import {anyChecked} from './utilities';
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import {SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT} from "../../constants";

const elementsMap = {
	ebayPartnerNameReviewTab : ".review-tab-partner-name",
	ebayPartnerName : "#ebayPartnerNameId",

	sectionTitlesReviewTab: ".section-step-title-inner",

  orderProcessingIcon: "#ebayOrderProcessingCheck",
  reviewTabOrderProcessingIcon: ".review-tab-order-processing-icon",

  orderProcessingStatusYes: ".order-processing-status-yes",
  orderProcessingDateTimeYes: ".order-processing-status-yes-date-time",

  orderProcessingStatusNo: ".order-processing-status-no",

  startDate:".start-date",
  timePickerHoursSelect: ".time-picker-hours-select",
  timePickerMinSelect: ".time-picker-minutes-select",
  timePickerPeriodSelect: ".time-picker-period-select",

  reviewTabTimePickerHoursSelect: ".review-tab-time-picker-hours-select",
  reviewTabTimePickerMinSelect: ".review-tab-time-picker-minutes-select",
  reviewTabTimePickerPeriodSelect: ".review-tab-time-picker-period-select",

  reviewTabDateSetter: ".review-tab-start-date-td",
  reviewTabTimeSetter: ".review-tab-start-time-td",

  orderProcessingDateTimeOptionsSelect:".orderProcessingDateTimeOptions",
}

export default function EbayReviewTab(wizard){
  const self = this;
  const wizardElement = wizard.getWizardElement();
  const els = {};
  const retpartner =wizardElement.data("retailer-partners-info");
	const saveConnectionSetupUrl = wizardElement.data("save-connection-setup-url");
	const completeConnectionSetup = wizardElement.data("complete-connection-setup-url");
	const ebayCmrDomainConfigData=wizardElement.data("ebay-connection-setup");
	const viewChannelsUrl = wizardElement.data("view-channel-url");
	const viewChannelDetailUrl = wizardElement.data("view-channel-detail-url");
	const parName=wizardElement.data("par-name");
	const parId=wizardElement.data("partner-id");
	const confirmationModalTxt=wizardElement.data("confirmation-modal-txt");
  let orderProcessingIconStatusReviewTab=false;
  let orderProcessingSelectValue="";
	const submitModalFlow = new SubmitModalFlow();
	submitModalFlow.init();

  self.init = function(){
    setElements();
    bindElements();
    fillChannelsReviewTab();
  };

  self.didNavigateToForm = function(){
    fillChannelsReviewTab();
  };

  function bindElements(){
    els.sectionTitlesReviewTab.bind('click', function(){
      const form = wizardElement.find($(this).data("target-form"));
      wizard.gotToForm(form);
    });
  }

  function setElements(){
    setElementsFromScope(els, elementsMap, wizardElement);
  }

  function setElementsFromScope(targetObj, elementsDict, scope){
    _(elementsDict).each((v, k)=>{
      //console.log(`${v} ${k}`)
      targetObj[k] = scope.find(v);
    });
  }

  function fillChannelsReviewTab(){
  	els.ebayPartnerNameReviewTab.text(els.ebayPartnerName.text());
    $(".review-tab-active-since").text(dateFromatCustomChange(retpartner.repActiveSince));

    setConfigurationReviewSection();
  }

  function setConfigurationReviewSection(){
    orderProcessingIconStatusReviewTab=anyChecked(els.orderProcessingIcon);
    setOrderProcessingOnReviewTab(orderProcessingIconStatusReviewTab);
    setReviewTabDate();
  }

  function setOrderProcessingOnReviewTab(data){
    if(data){
      els.orderProcessingStatusYes.show();
      els.orderProcessingDateTimeYes.show();
      els.orderProcessingStatusNo.hide();
    }else{
      els.orderProcessingStatusYes.hide();
      els.orderProcessingDateTimeYes.hide();
      els.orderProcessingStatusNo.show();
    }
  }

  function setReviewTabDate(){
    els.reviewTabDateSetter.text(els.startDate.val());
    setReviewTabTime();
    hideShowStartTimeSection();
  }

  function setReviewTabTime(){
    els.reviewTabTimePickerHoursSelect.text(els.timePickerHoursSelect.find("option:selected").val());
    els.reviewTabTimePickerMinSelect.text(els.timePickerMinSelect.find("option:selected").val());
    els.reviewTabTimePickerPeriodSelect.text(els.timePickerPeriodSelect.find("option:selected").val());
  }

  function hideShowStartTimeSection(){
    orderProcessingSelectValue = els.orderProcessingDateTimeOptionsSelect.find(":selected").val();

    if(orderProcessingSelectValue=="future" || orderProcessingSelectValue=="past"){
        els.orderProcessingDateTimeYes.show();
      }else{
        els.orderProcessingDateTimeYes.hide();
        els.startDate.val("");
        els.reviewTabTimePickerHoursSelect.val("");
        els.reviewTabTimePickerMinSelect.val("");
        els.reviewTabTimePickerPeriodSelect.val("");
      }
  }

  function dateFromatCustomChange(activeSince){
    if(activeSince!=null){
      var date = convertUTCDateToLocalDate(new Date(activeSince));
    }else{
      var date = new Date();
    }
    var curr_day = date.getDate();
    var curr_month = date.getMonth();
    var curr_year = date.getFullYear();
    curr_month++ ; // In js, first month is 0, not 1
    var newDate = curr_month + "/" + curr_day + "/" + curr_year;
    return newDate;
  }

  function convertUTCDateToLocalDate(date) {
    var newDate = new Date(date.getTime()+date.getTimezoneOffset()*60*1000);

    var offset = date.getTimezoneOffset() / 60;
    var hours = date.getHours();

    newDate.setHours(hours - offset);

    return newDate;
  }

	 $(".retPartner-save").click(function(e) {
	   saveConnection({ url: saveConnectionSetupUrl, success: saveSuccess, error: saveError, request:ebayCmrDomainConfigData });
	});

	$("#retPartner-save").click(function(e) {
	 let canSaveConn = canSave(wizard);
	 if(canSaveConn){
		 saveConnection({ url: saveConnectionSetupUrl, success: saveSuccess, error: saveError, request:ebayCmrDomainConfigData });
	 }
	});

	function canSave(wizard){
	      const currentForm = wizard.getActiveTargetForm();
	      let isValid = true;
	      if(currentForm.filter(".connections-tab").length){
	        isValid = areInputsValidForForm(currentForm);
	      }
	      return isValid;
	  }

	function areInputsValidForForm(form){
	    let inputs = wizard.findValidatableElementsForScope(form);
	    let valid = wizard.areInputsValid(inputs, {displayErrors: true});
	    return valid;
	  }

	  function saveConnection({url, success, error, request}) {
	    const submitModalFlow = new SubmitModalFlow({
	      confirmModalBody: `<div class="q-pad-all-xl">${confirmationModalTxt}</div>`,
	      onConfirmClick: function() {
	        submitModalFlow.showLoadingModal();
	        $.ajax({
	      		data: $('#create-ebay-channel-form').serialize(),
	      		url: url,
	      		dataType:"JSON",
	      		type: 'POST',
	      		success: saveSuccess,
	      		error: saveError
	      	});
	      }
	    });
	    submitModalFlow.init();
	 	 submitModalFlow.showConfirmModal();
	  }

	  function saveSuccess(){
	   EditChecker.setPageClean();
	   if(parId != "") {
	 		var detailPageUrl = `${viewChannelDetailUrl}&$&parId=${parId}&$&orgName=${parName}`;
	     submitModalFlow.showSuccessModal();
	     setTimeout(function() {
	       location.href = detailPageUrl;
	     }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	 	}else {
	     EditChecker.setPageDirty();
	 		 submitModalFlow.showFailureModal();
	 	}
	}

	  function saveError(){
	 	  submitModalFlow.hideAllModals();
	  }

}



// WEBPACK FOOTER //
// ./src/pages/createChannel/ebayReviewTab.js